import { Hero } from "components";
import {
  HomeContainer,
  Section,
  SectionTitle,
  AboutContent,
  StatsSection,
  StatCard,
  StatNumber,
  StatLabel,
  MemberImage,
  TeamMember,
  MemberName,
  MemberRole,
  MemberBio,
  TeamGrid,
  MemberLinkedIn,
  LinkedInIcon,
  EmailIcon,
  MemberSocialLinks,
  GamesGrid,
  GameCard,
  FeaturedGameCard,
  GameImage,
  GameContent,
  GameTitle,
  GameDescription,
  GameMeta,
  GameMetaItem,
  GameCTA,
  PlatformLink,
  TitleLink,
} from "./Home.styles";
import baris from "images/baristna.png";
import yigit from "images/yem.png";
import kayra from "images/keri.png";

import coverDesktopHeroes from "images/cover_desktop_heroes.png";
import coverFarmBoys from "images/cover_farm_boys.png";
import coverWarOfMine from "images/cover_war_of_mine.png";
// import coverCrazyColors from "images/cover_crazy_colors.png";
// import coverRoughBall from "images/cover_rough_ball.png";

import platformCrazyGames from "images/platform_crazy_games.png";
import platformSteamWishlist from "images/platform_steam_wishlist.png";
import iconLinkedin from "images/icon_in.png";
import iconEmail from "images/icon_email.png";

import press from "images/press.png";

// Animation variants
const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
};

const memberVariants = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: { opacity: 1, scale: 1 },
};

const gameVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 },
};

function Home() {
  return (
    <>
      <Hero
        variants={cardVariants}
        initial="hidden"
        animate="visible"
        transition={{ delay: 0.1 }}
      />

      <HomeContainer>
        <Section>
          <SectionTitle>Games</SectionTitle>
          <GamesGrid>
            <FeaturedGameCard
              variants={gameVariants}
              initial="hidden"
              animate="visible"
              transition={{ delay: 0.2 }}
            >
              <GameImage src={coverDesktopHeroes} alt="Desktop Heroes" />
              <GameContent>
                <div>
                  <GameTitle>
                    Desktop Heroes
                    <TitleLink
                      href="https://desktopheroes.telazer.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={press} alt="Press" />
                    </TitleLink>
                  </GameTitle>
                  <GameDescription>
                    Desktop Heroes is a fantasy idle action game designed to
                    quietly run at the bottom of your screen. Perfect for
                    players who want to make progress while working, studying,
                    or even attending meetings.
                  </GameDescription>
                  <GameMeta>
                    <GameMetaItem>Platform: Steam</GameMetaItem>
                    <GameMetaItem>OS: Windows, Mac, Linux</GameMetaItem>
                    <GameMetaItem>Idle</GameMetaItem>
                    <GameMetaItem>RPG</GameMetaItem>
                    <GameMetaItem>BoYS</GameMetaItem>
                  </GameMeta>
                </div>
                <GameCTA>
                  <PlatformLink
                    href="https://store.steampowered.com/app/3734200/Desktop_Heroes/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={platformSteamWishlist} alt="Steam" />
                  </PlatformLink>
                </GameCTA>
              </GameContent>
            </FeaturedGameCard>
            <FeaturedGameCard
              variants={gameVariants}
              initial="hidden"
              animate="visible"
              transition={{ delay: 0.2 }}
            >
              <GameImage src={coverFarmBoys} alt="Farm Boys" />
              <GameContent>
                <div>
                  <GameTitle>
                    Farm Boys
                    <TitleLink
                      href="https://farmboys.telazer.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={press} alt="Press" />
                    </TitleLink>
                  </GameTitle>
                  <GameDescription>
                    In Farm BoYS (Bottom of Your Screen), you embark on a cozy
                    idle farming adventure. While you watch your farm grow and
                    prosper, your workers take care of the tasks. Every action,
                    from planting vegetables to raising animals, brings your
                    farm closer to success.
                  </GameDescription>
                  <GameMeta>
                    <GameMetaItem>Platform: Steam</GameMetaItem>
                    <GameMetaItem>OS: Windows, Mac, Linux</GameMetaItem>
                    <GameMetaItem>Idle</GameMetaItem>
                    <GameMetaItem>Casual</GameMetaItem>
                    <GameMetaItem>BoYS</GameMetaItem>
                  </GameMeta>
                </div>
                <GameCTA>
                  <PlatformLink
                    href="https://store.steampowered.com/app/3839440/Farm_BoYS/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={platformSteamWishlist} alt="Steam" />
                  </PlatformLink>
                </GameCTA>
              </GameContent>
            </FeaturedGameCard>

            {/*<GameCard*/}
            {/*  variants={gameVariants}*/}
            {/*  initial="hidden"*/}
            {/*  animate="visible"*/}
            {/*  transition={{ delay: 0.3 }}*/}
            {/*>*/}
            {/*  <GameImage src={coverCrazyColors} alt="Crazy Colors" />*/}
            {/*  <GameContent>*/}
            {/*    <div>*/}
            {/*      <GameTitle>Crazy Colors</GameTitle>*/}
            {/*      <GameDescription>*/}
            {/*        Crazy Colors is a lively multiplayer battle where strategy*/}
            {/*        and chaos collide. Move across the arena to paint the ground*/}
            {/*        in your color while competing to cover 50% of the map first.*/}
            {/*      </GameDescription>*/}
            {/*      <GameMeta>*/}
            {/*        <GameMetaItem>Platform: CrazyGames</GameMetaItem>*/}
            {/*      </GameMeta>*/}
            {/*    </div>*/}
            {/*    <GameCTA>*/}
            {/*      <PlatformLink*/}
            {/*        href="https://www.crazygames.com/game/crazy-colors"*/}
            {/*        target="_blank"*/}
            {/*        rel="noopener noreferrer"*/}
            {/*      >*/}
            {/*        <img src={platformCrazyGames} alt="Crazy Games" />*/}
            {/*      </PlatformLink>*/}
            {/*    </GameCTA>*/}
            {/*  </GameContent>*/}
            {/*</GameCard>*/}

            <GameCard
              variants={gameVariants}
              initial="hidden"
              animate="visible"
              transition={{ delay: 0.4 }}
            >
              <GameImage src={coverWarOfMine} alt="War of Mine" />
              <GameContent>
                <div>
                  <GameTitle>War of Mine</GameTitle>
                  <GameDescription>
                    War of Mine is a captivating 2D side-camera game inspired by
                    the iconic Minecraft theme, reimagined with unique gameplay
                    mechanics and a strategic progression system.
                  </GameDescription>
                  {/*<GameMeta>*/}
                  {/*  <GameMetaItem>Platform: CrazyGames</GameMetaItem>*/}
                  {/*</GameMeta>*/}
                </div>
                <GameCTA>
                  <PlatformLink
                    href="https://www.crazygames.com/game/war-of-mine"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={platformCrazyGames} alt="Crazy Games" />
                  </PlatformLink>
                </GameCTA>
              </GameContent>
            </GameCard>

            {/*<GameCard*/}
            {/*  variants={gameVariants}*/}
            {/*  initial="hidden"*/}
            {/*  animate="visible"*/}
            {/*  transition={{ delay: 0.5 }}*/}
            {/*>*/}
            {/*  <GameImage src={coverRoughBall} alt="Rough Ball" />*/}
            {/*  <GameContent>*/}
            {/*    <div>*/}
            {/*      <GameTitle>Rough Ball</GameTitle>*/}
            {/*      <GameDescription>*/}
            {/*        Rough Ball is an exciting arcade-style game that challenges*/}
            {/*        players with fast-paced action and strategic gameplay in a*/}
            {/*        dynamic ball-based environment.*/}
            {/*      </GameDescription>*/}
            {/*      <GameMeta>*/}
            {/*        <GameMetaItem>Platform: CrazyGames</GameMetaItem>*/}
            {/*      </GameMeta>*/}
            {/*    </div>*/}
            {/*    <GameCTA>*/}
            {/*      <PlatformLink*/}
            {/*        href="https://www.crazygames.com/game/rough-ball-kvz"*/}
            {/*        target="_blank"*/}
            {/*        rel="noopener noreferrer"*/}
            {/*      >*/}
            {/*        <img src={platformCrazyGames} alt="Crazy Games" />*/}
            {/*      </PlatformLink>*/}
            {/*    </GameCTA>*/}
            {/*  </GameContent>*/}
            {/*</GameCard>*/}
          </GamesGrid>
        </Section>

        <Section>
          <SectionTitle>About Us</SectionTitle>

          <AboutContent
            variants={cardVariants}
            initial="hidden"
            animate="visible"
            transition={{ delay: 0.2 }}
          >
            <p>
              Founded in 2024, Telazer Games has reached over 5 million players
              with popular web-based titles such as War of Mine. These browser games quickly gained traction on social
              media and independent platforms thanks to their accessibility, art
              direction, and engaging gameplay.
            </p>
            <p>
              At Telazer, we believe that great games don’t require massive
              budgets—just bold ideas, tight mechanics, and a deep understanding
              of player behavior. We specialize in crafting experiences that
              resonate with both casual and core gamers. Our games are built to
              be fast, fun, and quicky accessible.
            </p>
            <p>
              We're a small, independent team with a big ambition: to redefine
              what's possible in gaming. We develop fast, always aiming to catch
              what players enjoy in the moment—because trends move quickly, and
              we believe great ideas shouldn't wait. Whether it's a competitive
              idle battler, a chaotic physics sandbox, or a vibrant arcade
              challenge, we design each title to be sharable, replayable, and
              memorable.
            </p>
            <p>
              Looking ahead, we're expanding into mobile and multiplayer
              experiences, while continuing to support and evolve our live
              games. Our ultimate goal? To build high-quality games with their
              own unique flavor—games that stand out, not just fit in.
            </p>
            <p>
              Our fast development cycle and agile approach also allow us to
              explore unconventional ideas and experimental genres. Right now,
              we’re working on a series of minimalist "bottom-of-your-screen"
              games—designed to be played casually, even while working, without
              breaking your focus. One of them is launching soon, and more are
              already on the way.
            </p>
          </AboutContent>

          <StatsSection>
            <StatCard
              variants={cardVariants}
              initial="hidden"
              animate="visible"
              transition={{ delay: 0.3 }}
            >
              <StatNumber>5M+</StatNumber>
              <StatLabel>Players Reached</StatLabel>
            </StatCard>

            <StatCard
              variants={cardVariants}
              initial="hidden"
              animate="visible"
              transition={{ delay: 0.4 }}
            >
              <StatNumber>3</StatNumber>
              <StatLabel>Games Released</StatLabel>
            </StatCard>

            <StatCard
              variants={cardVariants}
              initial="hidden"
              animate="visible"
              transition={{ delay: 0.5 }}
            >
              <StatNumber>2024</StatNumber>
              <StatLabel>Founded</StatLabel>
            </StatCard>
          </StatsSection>
        </Section>

        {/* Team Section */}
        <Section>
          <SectionTitle>Our Team</SectionTitle>

          <TeamGrid>
            <TeamMember
              variants={memberVariants}
              initial="hidden"
              animate="visible"
              transition={{ delay: 0.2 }}
            >
              <MemberImage src={baris} alt="BARIS TUNA BOTGUL" />
              <MemberName>BARIS TUNA BOTGUL</MemberName>
              <MemberSocialLinks>
                <MemberLinkedIn
                  href="https://www.linkedin.com/in/baristna/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <LinkedInIcon src={iconLinkedin} alt="LinkedIn" />
                </MemberLinkedIn>
                <MemberLinkedIn href="mailto:baris@telazer.com">
                  <EmailIcon src={iconEmail} alt="Email" />
                </MemberLinkedIn>
              </MemberSocialLinks>
              <MemberRole>
                Game and UI Developer <br /> UI/UX Designer
              </MemberRole>
              <MemberBio>
                With over 15 years of experience in software and design, he has
                worked on a wide range of web applications and games, combining
                technical skills with a sense for user experience His expertise
                lies in building intuitive interfaces, crafting engaging game
                UIs, and creating scalable front-end systems.
              </MemberBio>
            </TeamMember>

            <TeamMember
              variants={memberVariants}
              initial="hidden"
              animate="visible"
              transition={{ delay: 0.3 }}
            >
              <MemberImage src={yigit} alt="YIGIT EGE MIMAN" />
              <MemberName>YIGIT EGE MIMAN</MemberName>
              <MemberSocialLinks>
                <MemberLinkedIn
                  href="https://www.linkedin.com/in/yigitegemiman/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <LinkedInIcon src={iconLinkedin} alt="LinkedIn" />
                </MemberLinkedIn>
                <MemberLinkedIn href="mailto:yigit@telazer.com">
                  <EmailIcon src={iconEmail} alt="Email" />
                </MemberLinkedIn>
              </MemberSocialLinks>
              <MemberRole>
                Backend Developer <br /> Software Architect
              </MemberRole>
              <MemberBio>
                Over 10 years of experience in software development, with roles
                including Software Department Lead and Solutions Architect.
                Released 3 games and built 10+ prototypes, reaching over 1
                million players. Specializes in backend systems, real-time
                multiplayer games.
              </MemberBio>
            </TeamMember>

            <TeamMember
              variants={memberVariants}
              initial="hidden"
              animate="visible"
              transition={{ delay: 0.4 }}
            >
              <MemberImage src={kayra} alt="KAYRA KERI KUPCU" />
              <MemberName>KAYRA KERI KUPCU</MemberName>
              <MemberSocialLinks>
                <MemberLinkedIn
                  href="https://www.linkedin.com/in/kayrakerikupcu/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <LinkedInIcon src={iconLinkedin} alt="LinkedIn" />
                </MemberLinkedIn>
                <MemberLinkedIn href="mailto:kayra@telazer.com">
                  <EmailIcon src={iconEmail} alt="Email" />
                </MemberLinkedIn>
              </MemberSocialLinks>
              <MemberRole>
                Game Designer <br /> Producer
              </MemberRole>
              <MemberBio>
                Over 15 years of experience in gaming industry, he worked as a
                Manager, Game Designer and Producer with a focus on creating
                engaging gameplay systems and managing end-to-end game
                development. Experienced in turning ideas into playable
                experiences and leading teams through development.
              </MemberBio>
            </TeamMember>
          </TeamGrid>
        </Section>
      </HomeContainer>
    </>
  );
}

export default Home;
